module.exports = __webpack_public_path__ + "static/media/datasheet_onDemandPrinting_row0_product_image.b273875f.png";